import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import { MenuItemShare, useMenuItemPageCopy } from "@sprout/client-components/dist/MenuItemReusable";
import { MenuGrid, MenuTitle, MenuItem } from "@sprout/list-navigation/dist/Menu";
import { ItemType } from "sprout-graphql";
import { ArchiveOutlined, DeleteOutlined, RestoreFromTrashOutlined, UnarchiveOutlined } from "sprout-ui-icons";
import { PostPageToolbarMenuPopover, PostPageToolbarMenuCreatedAt } from "../PostPageToolbar";
const PostPageViewsTodoListToolbarMenu = (props)=>{
    const { todoList  } = props;
    const { isExplicitlyArchived , isExplicitlyDeleted , owner , createdAt  } = todoList;
    const authorization = usePostAuthorization(todoList);
    const [, MenuItemCopy] = useMenuItemPageCopy();
    return /*#__PURE__*/ _jsxs(PostPageToolbarMenuPopover, {
        children: [
            /*#__PURE__*/ _jsx(MenuTitle, {
                children: "To-do list options"
            }),
            /*#__PURE__*/ _jsx(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(MenuGrid, {}),
                children: authorization.archive && /*#__PURE__*/ _jsx(MenuItem, {
                    variant: "tile",
                    action: "PAGE_TOGGLE_ARCHIVE",
                    icon: isExplicitlyArchived ? UnarchiveOutlined : ArchiveOutlined,
                    label: isExplicitlyArchived ? "Unarchive" : "Archive"
                })
            }),
            /*#__PURE__*/ _jsx(MenuItemCopy, {
                type: "to-do list"
            }),
            /*#__PURE__*/ _jsx(MenuItemShare, {
                type: ItemType.Checklist
            }),
            authorization.trash && /*#__PURE__*/ _jsx(MenuItem, {
                action: "PAGE_TOGGLE_DELETE",
                label: isExplicitlyDeleted ? "Restore" : "Trash",
                icon: isExplicitlyDeleted ? RestoreFromTrashOutlined : DeleteOutlined
            }),
            authorization.delete && /*#__PURE__*/ _jsx(MenuItem, {
                action: "PAGE_PERMANENT_DELETE"
            }),
            owner && /*#__PURE__*/ _jsx(PostPageToolbarMenuCreatedAt, {
                createdAt: createdAt,
                owner: owner
            })
        ]
    });
};
export default PostPageViewsTodoListToolbarMenu;
